import React from 'react';
import history from '../../modules/History';
import { Button, notification } from 'antd';
import ReactTable from 'react-table'
import { getRolesList, removeRoleItem } from '../../modules/Api';
import ACL from '../../components/ACL';

class Roles extends React.Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 10,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        getRolesList((res) => {
            this.setState({items: res, count: res.length, pageSize: res.length});
        });
    }

    onChange(state) {

    }


    removeRole(id) {
        const warningMessage = `آیا از حذف کوپن اطمینان کامل دارید ؟ تمام اطلاعات مرتبط با آن حذف می شوند !`;
        if (window.confirm(warningMessage)) {

            removeRoleItem(id, (res) => {
                if(res.status == 200){
                    notification.open({
                        message: `نقش با موفقیت حذف شد`,
                    });
                    this.fetchData();
                }
                else if(res.message != undefined){
                    notification.open({
                        message: res.message,
                    });
                }
            });
        }
    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
                filterable: false,
            },
            {
                Header: 'عنوان',
                accessor: 'title',
                filterable: false,
                Cell: (row) => (row.original.name === "admin" ? row.original.title : (<ACL component="span" has_permission="acl_management|acl_edit" denied={() => {return row.original.title;}} ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}}
                                      title={row.original.title} onClick={() => {
                                          window.open(`/acl/roles/edit/${row.original.id}`, "_blank")
                                      }
                                      }> {row.original.title} </span></ACL>))
            },
            {
                Header: 'عملیات',
                accessor: 'delete',
                sortable: false,
                Cell: (row) => (row.original.name === "admin" ? "" : (
                    <React.Fragment>
                        <ACL component="span" has_permission="acl_management|acl_delete"><span onClick={() => {this.removeRole(row.original.id)}}  style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >X </span></ACL>
                    </React.Fragment>)
                )
            }
        ];


        return (
            <div style={{textAlign: 'center'}}>
                <ACL component="span" has_permission="acl_management|acl_add"><div className="btn-container">
                    <Button type="primary" onClick={() => history.item.push(`/acl/roles/add`)}>افزودن نقش جدید</Button>
                </div>
                </ACL>
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}


export default Roles;


// WEBPACK FOOTER //
// ./src/containers/ACL/roles.js